export const sameSupportId = (left, right) =>
  String(left || '').toLowerCase() === String(right || '').toLowerCase();

export const resolveSupportChatHubAccessToken = ({ isCustomerSurface, isManagementSession }) => {
  if (isCustomerSurface) {
    return localStorage.getItem('customer_auth_token') || '';
  }
  if (isManagementSession) {
    return localStorage.getItem('management_auth_token') || '';
  }
  return localStorage.getItem('customer_auth_token') || '';
};

export const shouldShowGuestEmailField = (visitorAuthenticated, hasGuestToken) =>
  !visitorAuthenticated && !hasGuestToken;

export const shouldOpenSupportFromLocation = (search) => {
  const params = new URLSearchParams(search || '');
  return params.get('support') === 'open';
};

export const messagesAfterVisitorSend = (previousConversationId, previousMessages, result) => {
  const incoming = result?.message;
  if (!incoming) {
    return previousMessages || [];
  }

  if (!sameSupportId(previousConversationId, result.conversationId)) {
    return [incoming];
  }

  if ((previousMessages || []).some((item) => sameSupportId(item.id, incoming.id))) {
    return previousMessages;
  }

  return [...(previousMessages || []), incoming];
};

export const supportInboxTitle = ({ isStoreInbox, storeName, initiatorDisplayName, storeFallback }) => {
  if (isStoreInbox) {
    return initiatorDisplayName || '';
  }
  const store = (storeName || '').trim();
  return store || storeFallback || '';
};

export const platformSupportNotificationText = (change) => {
  const sender = String(change?.lastSenderKind ?? '');
  const fromStore = sender === 'StoreStaff' || sender === '2';
  if (!fromStore) {
    return null;
  }
  const message = (change?.lastMessagePreview || '').trim();
  if (!message) {
    return null;
  }
  const storeName = (change?.storeName || '').trim();
  return storeName ? `${storeName}: ${message}` : message;
};

export const isSupportAdminSender = (senderKind) => {
  const value = String(senderKind ?? '');
  return value === '1' || value.toLowerCase() === 'appadmin';
};

export const isSupportStoreStaffSender = (senderKind) => {
  const value = String(senderKind ?? '');
  return value === '2' || value.toLowerCase() === 'storestaff';
};

export const isSupportVisitorSender = (senderKind) => {
  const value = String(senderKind ?? '');
  return value === '0' || value.toLowerCase() === 'visitor';
};

export const isVisitorWidgetOwnMessage = (senderKind, isStaffWidget) => (
  isStaffWidget
    ? !isSupportAdminSender(senderKind)
    : isSupportVisitorSender(senderKind)
);

export const isVisitorWidgetPeerTyping = (senderKind, isStaffWidget) => (
  isStaffWidget
    ? isSupportAdminSender(senderKind)
    : isSupportStoreStaffSender(senderKind)
);

export const isInboxOwnMessage = (senderKind, isStoreInbox) => (
  isStoreInbox
    ? isSupportStoreStaffSender(senderKind)
    : isSupportAdminSender(senderKind)
);

export const isInboxPeerTyping = (senderKind, isStoreInbox) => (
  isStoreInbox
    ? isSupportVisitorSender(senderKind)
    : !isSupportAdminSender(senderKind)
);

export const createSupportTypingReporter = ({ send, heartbeatMs = 2000 } = {}) => {
  let active = false;
  let timer = null;

  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    if (!active) {
      return;
    }
    active = false;
    send?.(false);
  };

  const ping = () => {
    if (!active) {
      active = true;
      send?.(true);
    }
    if (timer) {
      return;
    }
    timer = setInterval(() => send?.(true), heartbeatMs);
  };

  return { ping, stop };
};
